module.exports = "https://static.energy5.com/_next/static/images/software1-1b693192ceca5c32177ec5107f0760b9.png";